import { render, staticRenderFns } from "./ModalFormAgregarCarpetaAcademica.vue?vue&type=template&id=45f30628&scoped=true"
import script from "./ModalFormAgregarCarpetaAcademica.vue?vue&type=script&lang=js"
export * from "./ModalFormAgregarCarpetaAcademica.vue?vue&type=script&lang=js"
import style0 from "./ModalFormAgregarCarpetaAcademica.vue?vue&type=style&index=0&id=45f30628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f30628",
  null
  
)

export default component.exports